import router from "@/router"

const basicLayouts = {
  ManageLayout: () => import(`@/layouts/ManageLayout.vue`),
  RouteView: () => import(`@/layouts/RouteView.vue`)
}

const isValidRoutePath = path => {
  const paths = router.getRoutes()
  return paths.find(p => p.path === path)
}

const addRoutes = data => {
  const addedRoutes = router.getRoutes()
  const routes = [...data]
  routes.forEach(r => {
    if (r.type != '1') {
      return
    }
    if (addedRoutes.find(e => e.path === r.path)) {
      return
    }
    resetRouteData(r)
    router.addRoute(r)
  })
}

const getRootRoute = () => {
  const paths = router.getRoutes()
  return paths.find(p => {
    return p.meta?.root === '1'
  })
}

function resetRouteData(m) {
  const component = m.component
  if (!component) {
      return
  }
  m.component = basicLayouts[m.component] || loadView(m.component)
  m.meta = { title: m.name, key: m.key, root: m.parentId == null ? '1' : '0' }
  m.children && m.children.forEach(s => {
      resetRouteData(s)
  })
}

const loadView = (view, viewDefault) => {
  try {
    require(`@/views${view}`)
  } catch (err) {
    if (viewDefault) {
      try {
        require(`@/views${viewDefault}`)
      } catch (err) {
        return () => import(`@/views/exceptions/404`)
      }
      return () => import(`@/views${viewDefault}`)
    } else {
      return () => import(`@/views/exceptions/404`)
    }
  }
  return () => import(`@/views${view}`)
}

export {
  isValidRoutePath,
  addRoutes,
  getRootRoute
}